import React, { useState } from "react";

const ApplyHistoryModal = ({ data, setIsDetailModalOpen }) => {
  const [showChangedOnly] = useState(false);

  const formatValue = (value) => {
    if (value === null || value === undefined) {
      return "-";
    }

    if (typeof value === "boolean") {
      return value ? "예" : "아니오";
    }

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        try {
          return value
            .map((item) =>
              typeof item === "object"
                ? Object.entries(item)
                    .filter(
                      ([k]) =>
                        !k.includes("id") &&
                        !k.includes("pk") &&
                        !k.includes("path")
                    )
                    .map(([k, v]) => `${k}: ${v}`)
                    .join(", ")
                : String(item)
            )
            .join(" | ");
        } catch (e) {
          return JSON.stringify(value);
        }
      }
      return JSON.stringify(value);
    }

    return String(value);
  };

  const flattenHistoryData = () => {
    if (!data || !data.sections || !Array.isArray(data.sections)) {
      return [];
    }

    let flatData = [];

    data.sections.forEach((section) => {
      const changeType = section.key;

      if (section.fields && Array.isArray(section.fields)) {
        section.fields.forEach((field) => {
          flatData.push({
            changeType: changeType,
            changeDetail: field.sub_key,
            before: formatValue(field.before),
            after: formatValue(field.after),
            isChanged: field.changed,
          });
        });
      }
    });

    return flatData;
  };

  const historyItems = flattenHistoryData();

  const displayItems = showChangedOnly
    ? historyItems.filter((item) => item.isChanged)
    : historyItems;

  return (
    <>
      <div
        className="modal-background"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div
          className="personnel-modal-container"
          style={{
            backgroundColor: "white",
            borderRadius: "30px",
            width: "95%",
            height: "85vh",
            maxWidth: "1400px",
            display: "flex",
            flexDirection: "column",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            overflow: "hidden",
          }}
        >
          <div
            className="personnel-modal-header"
            style={{
              padding: "15px 20px",
              borderBottom: "1px solid #ddd",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <h3
                className="personnel-modal-title"
                style={{ margin: 0, marginRight: "20px" }}
              >
                출원 정보 변경 내역
              </h3>
            </div>
            <button
              onClick={() => setIsDetailModalOpen(false)}
              style={{
                padding: "6px 12px",
                background: "#f0f0f0",
                border: "1px solid #ddd",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              닫기
            </button>
          </div>

          <div
            className="personnel-modal-content"
            style={{
              padding: "0", // 패딩 제거하여 테이블 영역 확대
              overflow: "auto",
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%", // 높이를 100%로 설정
                overflow: "auto",
              }}
            >
              <table
                style={{
                  width: "100%",
                  tableLayout: "fixed",
                  borderCollapse: "collapse",
                  textAlign: "left",
                }}
              >
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "13%" }} />
                  <col style={{ width: "35%" }} />
                  <col style={{ width: "35%" }} />
                </colgroup>
                <thead>
                  <tr style={{ backgroundColor: "#f5f5f5", height: "50px" }}>
                    <th
                      style={{
                        padding: "10px 15px",
                        borderBottom: "1px solid #eee",
                        fontWeight: "bold",
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 10,
                        textAlign: "center",
                      }}
                    >
                      No.
                    </th>
                    <th
                      style={{
                        padding: "10px 15px",
                        borderBottom: "1px solid #eee",
                        fontWeight: "bold",
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 10,
                        textAlign: "center",
                      }}
                    >
                      변경유형
                    </th>
                    <th
                      style={{
                        padding: "10px 15px",
                        borderBottom: "1px solid #eee",
                        fontWeight: "bold",
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 10,
                        textAlign: "center",
                      }}
                    >
                      변경내역
                    </th>
                    <th
                      style={{
                        padding: "10px 15px",
                        borderBottom: "1px solid #eee",
                        fontWeight: "bold",
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 10,
                        textAlign: "center",
                      }}
                    >
                      변경전
                    </th>
                    <th
                      style={{
                        padding: "10px 15px",
                        borderBottom: "1px solid #eee",
                        fontWeight: "bold",
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 10,
                        textAlign: "center",
                      }}
                    >
                      변경후
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {displayItems.length > 0 ? (
                    displayItems.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor: item.isChanged
                            ? "#fff8e6"
                            : index % 2 === 0
                            ? "#ffffff"
                            : "#f9f9f9",
                        }}
                      >
                        <td
                          style={{
                            padding: "12px 15px",
                            borderBottom: "1px solid #eee",
                            whiteSpace: "nowrap",
                            textAlign: "center",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            padding: "12px 15px",
                            borderBottom: "1px solid #eee",
                            wordBreak: "keep-all",
                            textAlign: "center",
                          }}
                        >
                          {mapKeyToKorean(item.changeType) || "-"}
                        </td>
                        <td
                          style={{
                            padding: "12px 15px",
                            borderBottom: "1px solid #eee",
                            wordBreak: "keep-all",
                            textAlign: "center",
                          }}
                        >
                          {mapSubKeyToKorean(item.changeDetail) || "-"}
                        </td>
                        <td
                          style={{
                            padding: "12px 15px",
                            borderBottom: "1px solid #eee",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            textAlign: "center",
                            maxWidth: 0,
                          }}
                        >
                          {item.before}
                        </td>
                        <td
                          style={{
                            padding: "12px 15px",
                            borderBottom: "1px solid #eee",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            textAlign: "center",
                            maxWidth: 0,
                          }}
                        >
                          {item.after}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        style={{
                          padding: "40px 20px",
                          textAlign: "center",
                          fontSize: "16px",
                          color: "#666",
                        }}
                      >
                        {showChangedOnly
                          ? "변경된 데이터가 없습니다."
                          : "데이터가 없습니다."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapKeyToKorean = (key) => {
  const keyMap = {
    master: "기본 정보",
    details: "상세 정보",
    applicant_info: "출원인 정보",
    marks: "상표 정보",
    detail_items: "상품 정보",
  };

  return keyMap[key] || key;
};

const mapSubKeyToKorean = (subKey) => {
  const subKeyMap = {
    power_of_attorney_original_filename: "위임장 파일 이름변경",
    tel_number: "유선 전화",
    created_at: "변경 일자",
    image_filename: "이미지 이름",
    image_path: "이미지 변경",
    address: "주소",
    name_kor: "이름(한글)",
    name_eng: "이름(영문)",
    phone_number: "전화번호",
    email: "이메일",
    zip_code: "우편번호",
    detail_address: "상세주소",
    marks: "상표명",
    details: "상세정보",
    detail_items: "상세항목",
    social_security_number: "주민등록번호",
    tax_invoice_type: "세금계산서 유형",
    progress_status: "진행상태",
    is_confirmed: "승인여부",
    mark_type: "상표유형",
    user_pk: "사용자 ID",
    applicant_type: "출원인 유형",
    agent_email: "대리인 이메일",
    agent_phone: "대리인 전화번호",
    agent_company: "대리인 회사",
    agent_name: "대리인 이름",
    phone: "전화번호",
    company: "회사명",
    biz_regist_number: "사업자등록번호",
    patent_customer_number: "특허고객번호",
    delegation_consent: "위임동의",
    collection_consent: "수집동의",
  };

  return subKeyMap[subKey] || subKey;
};

export default ApplyHistoryModal;
